export const primarycolor='#41B715'
